import React, { useState, useEffect, useRef, useMemo } from "react";
import clsx from "clsx";
import { useMediaQuery } from "react-responsive";
import { motion } from "framer-motion";

import { iconVision, iconAim, iconValue } from "../../assets/images";
import { mediaQueries } from "../../constant";
import styles from "./styles.module.scss";

const data = [
  {
    title: "Visi",
    desc: "Menjadi pelopor pasar industri peralatan rumah tangga",
    icon: iconVision,
  },
  {
    title: "Misi",
    desc: "Menyediakan berbagai produk berkualitas & inovatif untuk keluarga, juru masak rumah & koki dan untuk memastikan gaya hidup yang sehat",
    icon: iconAim,
  },
  // {
  //   title: "Value",
  //   desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
  //   icon: iconValue,
  // },
];

function VisiMisi({}) {
  const refVisi = useRef();
  const refMisi = useRef();
  const refValue = useRef();
  const [elementVisi, setElementVisi] = useState(0);
  const [elementMisi, setElementMisi] = useState(0);
  const [elementValue, setElementValue] = useState(0);

  const [startingPoint, setStartingPoint] = useState(0);
  const [showElementVisi, setShowElementVisi] = useState(false);
  const [showElementMisi, setShowElementMisi] = useState(false);
  const [showElementValue, setShowElementValue] = useState(false);

  const isBiggerScreen = useMediaQuery({
    query: `(min-device-width: ${mediaQueries?.miniDesktop}px)`,
  });
  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: isBiggerScreen ? 0.3 : 0.5,
        },
      },
    }),
    [isBiggerScreen]
  );
  const variantContentVisi = useMemo(
    () => ({
      offScreen: { y: 100, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1,
        },
      },
    }),
    []
  );
  const variantContentMisi = useMemo(
    () => ({
      offScreen: { y: 100, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1,
          delay: 0.5,
        },
      },
    }),
    []
  );
  const variantContentValue = useMemo(
    () => ({
      offScreen: { y: 100, opacity: 0 },
      onScreen: {
        y: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1,
          delay: 1,
        },
      },
    }),
    []
  );

  const checkScrollCondition = () => {
    if (
      window.pageYOffset > 0 &&
      elementVisi > 0 &&
      window.pageYOffset + startingPoint > elementVisi
    ) {
      setShowElementVisi(true);
    } else {
      setShowElementVisi(false);
    }
    if (
      window.pageYOffset > 0 &&
      elementMisi > 0 &&
      window.pageYOffset + startingPoint > elementMisi
    ) {
      setShowElementMisi(true);
    } else {
      setShowElementMisi(false);
    }
    if (
      window.pageYOffset > 0 &&
      elementValue > 0 &&
      window.pageYOffset + startingPoint > elementValue
    ) {
      setShowElementValue(true);
    } else {
      setShowElementValue(false);
    }
  };

  const checkInView = (index) => {
    switch (index) {
      case 0:
        return showElementVisi ? "onScreen" : "offScreen";
      case 1:
        return showElementMisi ? "onScreen" : "offScreen";
      case 2:
        return showElementValue ? "onScreen" : "offScreen";
    }
  };

  useEffect(() => {
    const setValues = () => {
      setStartingPoint(window.innerHeight * 0.9);
      if (refVisi.current) setElementVisi(refVisi.current.offsetTop);
      if (refMisi.current) setElementMisi(refMisi.current.offsetTop);
      if (refValue.current) setElementValue(refValue.current.offsetTop);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, [refVisi]);

  useEffect(() => {
    document.addEventListener("scroll", checkScrollCondition, {
      passive: true,
    });

    return () => {
      document.removeEventListener("scroll", checkScrollCondition, {
        passive: true,
      });
    };
  });
  return (
    <div className={clsx("mt-12 lg:py-12", styles.visiMisi)}>
      <motion.ul
        className={clsx(
          "overflow-hidden flex flex-wrap justify-center",
          styles.container
        )}
        variants={variantContainer}
        initial="offScreen"
        whileInView="onScreen"
      >
        {data?.map((item, index) => (
          <motion.li
            ref={index === 0 ? refVisi : index === 1 ? refMisi : refValue}
            variants={
              index === 0
                ? variantContentVisi
                : index === 1
                ? variantContentMisi
                : variantContentValue
            }
            initial="offScreen"
            whileInView={() => checkInView(index)}
            key={`${index}_${item?.title}`}
            className={clsx("w-full lg:w-1/3 flex flex-column", {
              "mt-4 lg:m-0 ": index !== 0,
            })}
          >
            <div className="flex-1 mx-4 p-4 border rounded-md">
              <h4 className="headline-remo text-3xl text-center">
                {item?.title}
              </h4>
              <div className="w-1/3 mt-8 mx-auto relative">
                <img src={item?.icon} alt={`img-${item?.title}`} />
              </div>
              <p className="mt-8 text-base lg:text-xl text-center">
                {item?.desc}
              </p>
            </div>
          </motion.li>
        ))}
      </motion.ul>
    </div>
  );
}

export default VisiMisi;
